
export const images = {
    'allyIcon': {
        'default': require('./ally-icon.png'),
        'white': require('./ally-icon-white.png')
    },
    'indicators': {
        'high': {
            'circle': require('./ally-icon-indicator-high-circle.svg'),
            'default': require('./ally-icon-indicator-high.svg')
        },
        'low': {
            'circle': require('./ally-icon-indicator-low-circle.svg'),
            'default': require('./ally-icon-indicator-low.svg')
        },
        'medium': {
            'circle': require('./ally-icon-indicator-medium-circle.svg'),
            'default': require('./ally-icon-indicator-medium.svg')
        },
        'perfect': {
            'circle': require('./ally-icon-indicator-perfect-circle.svg'),
            'default': require('./ally-icon-indicator-perfect.svg')
        }
    },
    'loading': require('./loading.svg'),
    'materialIcons': {
        'close': require('./material-icons/ic_clear_white_24px.svg'),
        'dropdown': require('./material-icons/ic_arrow_drop_down_black_24px.svg')
    },
    'seizureFlag': require('./ally-icon-seizure-flag.svg')
};
